import styled from "styled-components";

export const StyledContainer = styled("div")`
  display:flex;
  flex-direction:column;
  text-align: center;
  justify-content: center;
  align-items: center;
  width:100%;
  direction:rtl;
`;

export const PageTitle = styled("p")`
  display:flex;
  flex-direction:column;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin-bottom:15px;
`;

export const ContentContainer = styled("div")`
  padding: 5px; 
  background-color:white;
  box-shadow: 1px 1px #C5C7C6  ;
  border: solid 1px #C5C7C6;
  border-radius: 2px; 
  width:100%;
`;
export const ButtonContainer = styled("div")`
  display:flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding:10px;
`;

export const FooterContainer = styled("div")`
  display:flex;
  flex-direction:column;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding:10px;
`;